import React, { useEffect, useRef } from "react";
import AgoraCall from "./AgoraCall";
import { GetMeetingDetails } from "../../../services/chat.services";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";

function AgoraApp() {
    const navigate = useNavigate();
    const meetingDetailsRef = useRef(null);
    const [meetingDetails, setMeetingDetails] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [searchParams] = useSearchParams();
    const meetingId = searchParams.get('meeting_id');

    async function getMeetingDetails(){
      console.log('---meetingId', meetingId);
          try {
            // const response = await GetMeetingDetails({meeting_id : '69269ad3afd80d983b7bd6b9'});
            const response = await GetMeetingDetails({meeting_id : meetingId});
            const data = response.data;
    
            //TODO: check current time with meeting start time, if meeting date and time are valid or not  
            const meetingStartDate = new Date(data.meeting_date);
            const currentDate = new Date();
    

            //generate token
            const uid = Math.floor(Math.random() * 10000);
            const channel = data?.channel;
            // Get token from server
            const res = await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/generate-agora-token?channel=${channel}&uid=${uid}`);
            const token = res.data.token;

            meetingDetailsRef.current = {
                ...data,
                uid,
                channel,
                token
            };
            setMeetingDetails(meetingDetailsRef.current);
            setLoading(false);

          } catch (error) {
            Swal.fire({
              icon: "error",
              text: error.message || 'Something went wrong',
              ...SWAL_SETTINGS,
            });
            navigate(-1);
            setLoading(false);
        }
    }

    useEffect(() => {
        getMeetingDetails();
    }, []);

    console.log('-----meetingDetails', meetingDetails);

  return (
    <>
    {loading ? (
      <div>Loading...</div>
    ) : (
      <AgoraCall
        channel={meetingDetails?.channel}
        token={meetingDetails?.token}
        uid={meetingDetails?.uid}
        callType={meetingDetails?.meeting_type || "video"}
        astroName={meetingDetails?.psychic_name}
        astroImage={meetingDetails?.psychic_profile_image}
        userName={meetingDetails?.user_name || "Customer"}
        userImage={meetingDetails?.user_image || "https://via.placeholder.com/100"}
        endTimeUTC={meetingDetails?.end_time || "2025-11-26T15:30:00Z"}
    />
    )}
    </>
  );
}

export default AgoraApp;